import { h } from 'vue'
import MoleculeReviewG2 from '~/components/molecules/review-g2/review-g2.vue'
import OrganismTestimonials from '~/components/organisms/testimonials/testimonials.vue'
import UiComponentContainer from '~ui/components/container/container.vue'

const Functional = (props) => {
  return h(UiComponentContainer, { class: 'reviews' }, () => [
    h(MoleculeReviewG2, {
      medals: props.componentCertification.medals,
    }, {
      tag: () => props.componentCertification.tag,
      heading: () => props.componentCertification.title,
    }),
    h(OrganismTestimonials, {
      testimonials: props.record.customers.map(review => ({
        customer: {
          avatar: review?.authorPicture,
          name: review?.authorUserStory,
          position: review?.authorPosition,
        },
        logo: review?.logoColor,
        quote: review?.quote,
      })),
      to: '',
    }),
  ])
}

Functional.props = {
  componentCertification: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
